var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.userId)?_c('em',[_vm._v(" Login to connect with Slack ")]):_c('Button',{attrs:{"text":"","color":"brandPrimary"},on:{"click":_vm.openSlackInstall}},[_vm._v("Add to Slack")])
}
var staticRenderFns = []

export { render, staticRenderFns }